import { Button } from "@hortis/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@hortis/ui/dialog";
import { toast } from "@hortis/ui/sonner";
import {
  namedOperations,
  useUpdatePlantMaterialMutation,
} from "generated/graphql";
import { useState } from "react";
import { queryClient } from "src/app";

interface MakePublicDialogProps {
  id: string;
  onSuccess?: () => void;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const MakePublicDialog = ({
  id,
  onSuccess,
  open,
  onOpenChange,
}: MakePublicDialogProps) => {
  const [_, updatePlantMaterial] = useUpdatePlantMaterialMutation();
  const [loading, setLoading] = useState<boolean>(false);

  const onSubmit = async () => {
    setLoading(true);
    const res = await updatePlantMaterial({
      materialId: id,
      updates: {
        public: true,
      },
    });
    setLoading(false);
    if (res.data?.updatePlantMaterial?.__typename !== "PlantMaterial") {
      toast.error("Failed to update material");
      return;
    }
    toast.success("Successfully updated material");
    void queryClient.invalidateQueries({
      queryKey: [namedOperations.Query.GetMaterial],
    });
    void queryClient.invalidateQueries({
      queryKey: [namedOperations.Query.GetMaterialById],
    });
    void queryClient.invalidateQueries({
      queryKey: [namedOperations.Query.PlantMaterials],
    });
    onOpenChange(false);
    onSuccess?.();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-cy="make-public-dialog">
        <DialogHeader>
          <DialogTitle>Make material public?</DialogTitle>
          <DialogDescription>
            It will be displayed on this public site.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose asChild>
            <Button size="sm">Cancel</Button>
          </DialogClose>
          <Button
            size="sm"
            variant="primary"
            loading={loading}
            testId="make-public-confirm"
            onClick={onSubmit}
          >
            Confirm
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export { MakePublicDialog };
